// extracted by mini-css-extract-plugin
module.exports = {"vsp7v5a":"vsp7v5a","title":"title","category":"category","btn":"btn","active":"active","rank":"rank","rank-0":"rank-0","rank-1":"rank-1","rank-2":"rank-2","left":"left"};